import { DEG_TO_RAD } from './constants';
export default function deg(radians) {
  return radians / DEG_TO_RAD;
}